import { API } from "@swivl-mono/api-helper";
import { EmbedInterface, OrgInterface } from "@swivl-mono/types";
import { LayoutWithSidebar, Spinner } from "@swivl-mono/ui";
import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";

import { SidebarLink } from "../../../Components/SidebarLink/SidebarLink";
import { EmbedTesterEmbedsView } from "./EmbedTesterEmbedsView";

export default function EmbedTester() {
  const [orgs, setOrgs] = useState<OrgInterface[]>([]);
  const [embeds, setEmbeds] = useState<EmbedInterface[]>([]);

  const params = useParams();
  useEffect(() => {
    API.Org.getAllOrgs().then((orgs) => {
      setOrgs(orgs.sort((a, b) => a.name.localeCompare(b.name)));
    });
    // return () => {
    //     (window as any).Swivl.unmount();
    // }
  }, []);

  useEffect(() => {
    setEmbeds([]);
    if (params.orgId) {
      API.Embeds.getEmbeds(parseInt(params.orgId)).then((embeds) => {
        setEmbeds(embeds.sort((a, b) => a.name.localeCompare(b.name)));
      });
    }
  }, [params.orgId]);

  return (
    <LayoutWithSidebar
      sidebar={
        <div className="flex flex-col">
          {orgs ? (
            orgs.map((org) => (
              <SidebarLink key={org.id} to={`/admin/embed/${org.id}`}>
                {org.name}
              </SidebarLink>
            ))
          ) : (
            <Spinner />
          )}
        </div>
      }
      contentNoPadding={true}
      content={
        params.orgId ? (
          <EmbedTesterEmbedsView key={params.orgId + "_" + params.embedId} embedId={params.embedId} orgId={params.orgId} embeds={embeds} />
        ) : (
          <></>
        )
      }
    />
  );
}
